import React from 'react'
import Layout from '../../brands/components/Layout'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'

const ImportantInfo: React.FC = () => {
    const navigate = useNavigate()
    const column = [
        {
            key: 'title',
            name: 'Title',
            resizable: true,
            sortable: true,
        },
        {
            key: 'date',
            name: 'Date',
            resizable: true,
            sortable: true,
        },
        {
            key: 'time',
            name: 'Time',
            resizable: true,
            sortable: true,
        },
        {
            key: 'actions',
            name: 'Actions', // Fix the typo here
            resizable: true,
            renderCell: () => (
                <>
                    <div className="dropdown-custom-link">
                        <Icon
                            // onClick={() => {
                            //     setEditHolidayModal(true)
                            // }}
                            icon="bx:edit"
                            className="icon-primary"
                        />
                        <Icon
                            // onClick={() => {
                            //     setShowDeleteModal(true)
                            // }}
                            icon="icon-park-outline:delete"
                            className="icon-secondary"
                        />
                    </div>
                </>
            ),
        },
    ]

    const rows = []

    for (let i = 0; i < 7; i++) {
        rows.push({
            title: 'Lorem ipsum dolor sit amet consectetur',
            date: 'Jan 1, 2024',
            time: '9:00 AM',
        })
    }

    return (
        <div>
            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>Manage Important Information</h4>
                            </div>
                            <div className="col-sm-6">
                                <div className="custom-btn-design">
                                    <a
                                        onClick={() => {
                                            navigate('/imp-info/upload')
                                        }}
                                        className="button button-primary button-align-right"
                                    >
                                        UPLOAD ITEM
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <>
                        <DataGrid
                            className="data-grid-table"
                            columns={column}
                            rows={rows}
                            rowHeight={60}
                            headerRowHeight={40}
                        />
                    </>
                </div>
            </Layout>
        </div>
    )
}

export default ImportantInfo
